// extracted by mini-css-extract-plugin
export default {"nav_item":"NavItem_nav_item__6QSpr","nav_item_active":"NavItem_nav_item_active__wERAa"};